import styles from './admin-company.module.scss';
import { Box, Container, Divider, PrimaryButton, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import { AdminAllCompanies, CompaniesCreated, GetCurrentCompany, MoveUsersToNewCompanyDialog } from '@frontend-workspace/webkua-lib';
import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import PageTitle from '../page-title/page-title';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface AdminCompanyProps { }

export function AdminCompany(props: AdminCompanyProps) {
  const { t } = useTranslation();
  const [isMoveUsersToNewCompanyModalOpen, setIsMoveUsersToNewCompanyModalOpen] = useState<boolean>(false);
  const currentCompany = GetCurrentCompany();

  const handleMoveUsersToNewCompany = () => setIsMoveUsersToNewCompanyModalOpen(true);
  const handleCloseModal = () => setIsMoveUsersToNewCompanyModalOpen(false);
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const navigateToAllCompanies = () => setSelectedTab(0);
  const navigateToNewCompanies = () => setSelectedTab(1);
  return <>
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.company")} subtitle={`(${t("standard.admin")})`} />
            <PrimaryButton
              onClick={handleMoveUsersToNewCompany}
              variant="contained"
              disabled={!currentCompany}>
              {t("adminCompany.moveUsersToNewCompany")}
            </PrimaryButton>
            <Divider className="my-4" />
            <Tabs
              value={selectedTab}
              variant="scrollable"
              scrollButtons="auto">
              <Tab label={t("standard.allCompanies")} onClick={navigateToAllCompanies} />
              <Tab label={t("standard.newCompanies")} onClick={navigateToNewCompanies} />

            </Tabs>
            {selectedTab === 0 && <AdminAllCompanies />}
            {selectedTab === 1 && <CompaniesCreated />}
          </Box>
        </Col>
      </Row>
    </Container>
    {isMoveUsersToNewCompanyModalOpen && currentCompany &&
      <MoveUsersToNewCompanyDialog
        currentCompany={currentCompany}
        onClose={handleCloseModal}
      />
    }
  </>;
}

export default AdminCompany;